import React from 'react';
import { termsData, termsDataMonths } from "../../enums/termsData";

export default function template(context) {
    const calc = context.calc,
        model = calc.state.model,
      terms = model.getTerms().map((item, index) => {
          return (
            <button className={`term-btn ${item === Number(model.getCreditTerm()) ? 'active' : ''}`} name="loanTerm" key={item} onClick={calc.handleChange} value={index}>
                {termsDataMonths[item].value} {calc.l10n(termsDataMonths[item].text)}
            </button>
          )
      }),
      amountBtns = (
        <div className="calculator-amount-wrapper">
          {model.getFixAmounts().map((item, index) => {
            return (
              <button className={`amount-btn ${+item === Number(model.getCreditSum()) ? 'active' : ''}`} name="creditSum" key={index} onClick={calc.handleChange} value={item}>
                {(+item).toLocaleString() + ' ' + calc.l10n('UAH_ICON')}
              </button>
            )
          })}
        </div>
      )
      /*sumOrient = (
        <>
            <div>{(model.getMinSumEdge()).toLocaleString('RU-ru') + ' ' + calc.l10n('UAH_ICON')}</div>
            <div>{(model.getMaxSumEdge() / 2).toLocaleString('RU-ru') + ' ' + calc.l10n('UAH_ICON')}</div>
            <div>{(model.getMaxSumEdge()).toLocaleString('RU-ru') + ' ' + calc.l10n('UAH_ICON')}</div>
        </>
      )*/;

    return (
      <React.Fragment>
          <div className="calculator-controllers">
              <div className="calc-title">{calc.l10n('CREDIT_INSTALLMENT_CALC')}</div>
              <div className="calc-mode-description">
                  {calc.l10n("GREEN_CARD_CALC_SUBTITLE")}
                  <div className="green">{model.getMonthCommission() + calc.l10n("PERCENT")}</div>
              </div>
              <div className="controller-block">
                  <div className="calc-block-title">
                      {calc.l10n('CREDIT_QUICK_CASH_SUM')}
                  </div>

                  {/*<div className="calculator-slider-wrapper">*/}
                  {/*    <div className="calculator-input-wrapper">*/}
                  {/*        <input name="creditSum" type="text"*/}
                  {/*               className="calculator-slider-value"*/}
                  {/*               value={model.getCreditSum().toLocaleString('RU-ru')}*/}
                  {/*               onChange={calc.handleChangeInput}*/}
                  {/*               onBlur={calc.blurChangeInput}*/}
                  {/*               max={model.getMaxSumEdge()}*/}
                  {/*               min={model.getMinSumEdge()}>*/}
                  {/*        </input>*/}
                  {/*        <span ref={calc.hiddenValue} className='hidden-value'>{model.getCreditSum().toLocaleString('RU-ru')}</span>*/}
                  {/*        <span style={{left: `${calc.state.valueWith + 20}px`}}>{calc.l10n('UAH_ICON')}</span>*/}
                  {/*    </div>*/}
                  {/*    <input type="range"*/}
                  {/*           name="creditSum"*/}
                  {/*           className="calculator-sum-slide"*/}
                  {/*           onChange={calc.handleChange}*/}
                  {/*           value={model.getCreditSum()}*/}
                  {/*           min={model.getMinSumEdge()}*/}
                  {/*           max={model.getMaxSumEdge()}*/}
                  {/*           step={model.getSumStep()}*/}
                  {/*           style={{background: `linear-gradient(90deg, #00D352 ${calc.state.rangePercent}%, rgba(13, 12, 34, 0.1) ${calc.state.rangePercent}%)`}}*/}
                  {/*    />*/}
                  {/*</div>*/}
                  {/*<div className="calculator-slider-orient">*/}
                  {/*    {sumOrient}*/}
                  {/*</div>*/}
                {amountBtns}
              </div>
              <div className="controller-block terms">
                  <div className="calc-block-title">
                      {calc.l10n('CREDIT_QUICK_CASH_TERM')}
                  </div>
                  <div className="calculator-terms-wrapper">
                      {terms}
                  </div>
              </div>
          </div>
      </React.Fragment>
    );
}
